import { cn } from "@/lib/utils"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"

interface FormSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  children: React.ReactNode
  isActive: boolean
  isCompleted: boolean,
  description?:string
}

export function FormSection({ title, children, isActive,description, isCompleted, className, ...props }: FormSectionProps) {
  return (
    <Card
      className={cn(
        "transition-all duration-200",
        isActive ? "opacity-100" : "opacity-50",
        isCompleted && "border-primary",
        className,
      )}
      {...props}
    >
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {title}
          {isCompleted && (
            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary text-xs text-primary-foreground">
              ✓
            </span>
          )}
        </CardTitle>
        {
          description && <CardDescription className="text-gray-500">{description}</CardDescription>
        }
      </CardHeader>
      <Separator />
      <CardContent className="pt-6">{children}</CardContent>
    </Card>
  )
}

